import './visit.css'

function Visit() {
    return (
        <div className='visit'>
            <div className='visitWrapper'>
                <div className='visit-left'>
                    <div className='visit-left-container'>
                        <img src={require('../../assets/house1.jpg')} alt=''/>
                        <div className='visit-left-desc'>
                            <h1>Plan for a preriminary</h1>
                            <p><i class="fas fa-quote-left fa-2x"></i>Our visit to the areas where our properties are located is done offenly.
                               Register for a visit to areas you wish to rent | buy today.<i class="fas fa-quote-right fa-2x"></i>
                            </p>
                        </div>
                    </div>
                </div>
                <div className='visit-right'>
                <h5>Register for a preliminary</h5>
                   <form className='visit--form'>
                       <input type='text' placeholder='Enter name eg. Joshau Maina'/>
                       <input type='text' placeholder='Enter email eg. joshua@gmail.com'/>
                       <input type='text' placeholder='Enter name eg.+254756431290'/>
                       <select plcaeholder='Select day'>
                           <option value='Wednesday'>Wednesday</option>
                           <option value='Saturday'>Saturday</option>
                       </select>
                       <button type='submit'>Register</button>
                       <div className='formIcons'>
                         <a href='https://web.facebook.com/Exquisite-services-100825231775219' target='_blank'><i className="fab fa-facebook "></i></a>  
                           <i className="fab fa-twitter "></i>
                          <a href='https://www.instagram.com/ngigearthur/' target='_blank'><i className="fab fa-instagram "></i></a> 
                       <a href='https://www.linkedin.com/in/arthur-mwangi-7a80761bb/' target="_blank"> <i class="fab fa-linkedin-in"></i></a>
                       </div>
                   </form>
                </div>
            </div>
        </div>
    )
}

export default Visit
